function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import _ from 'lodash';
import { CHECKOUT_LINE_ITEM_MAPPING } from '../constants';
/**
 * Transforms order/cart receipt data into checkout line items format
 * Single source of truth for both Cart and Order receipts
 * @param {Object} orderOrCostBreakdown - The order object or cart costBreakdown with receipt details
 * @param {Object} options - Optional settings
 * @param {boolean} [options.hideDiscounts=false] - Whether to hide discounts from consumer
 * @param {boolean} [options.hideSalesLanguage=false] - Whether to hide sales language (controlled by storeSettings.restrictSalesLanguage)
 * @returns {Array<{type: string, value: number}>} - Array of line items
 */ export function getCheckoutLineItemsFromOrder(orderOrCostBreakdown) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _orderOrCostBreakdown_receipt_details, _orderOrCostBreakdown_receipt, _orderOrCostBreakdown_receipt_details_order, _orderOrCostBreakdown_receipt_details1, _orderOrCostBreakdown_receipt1, _orderOrCostBreakdown_receipt2;
    if (!orderOrCostBreakdown || !orderOrCostBreakdown.receipt) {
        return [];
    }
    var _options_hideDiscounts = options.hideDiscounts, hideDiscounts = _options_hideDiscounts === void 0 ? false : _options_hideDiscounts, _options_hideSalesLanguage = options.hideSalesLanguage, hideSalesLanguage = _options_hideSalesLanguage === void 0 ? false : _options_hideSalesLanguage;
    var _orderOrCostBreakdown_receipt_details_taxBreakdown;
    var taxLineItems = (_orderOrCostBreakdown_receipt_details_taxBreakdown = (_orderOrCostBreakdown_receipt = orderOrCostBreakdown.receipt) === null || _orderOrCostBreakdown_receipt === void 0 ? void 0 : (_orderOrCostBreakdown_receipt_details = _orderOrCostBreakdown_receipt.details) === null || _orderOrCostBreakdown_receipt_details === void 0 ? void 0 : _orderOrCostBreakdown_receipt_details.taxBreakdown) !== null && _orderOrCostBreakdown_receipt_details_taxBreakdown !== void 0 ? _orderOrCostBreakdown_receipt_details_taxBreakdown : {};
    var _orderOrCostBreakdown_receipt_details_order_fees;
    var feeLineItems = (_orderOrCostBreakdown_receipt_details_order_fees = (_orderOrCostBreakdown_receipt1 = orderOrCostBreakdown.receipt) === null || _orderOrCostBreakdown_receipt1 === void 0 ? void 0 : (_orderOrCostBreakdown_receipt_details1 = _orderOrCostBreakdown_receipt1.details) === null || _orderOrCostBreakdown_receipt_details1 === void 0 ? void 0 : (_orderOrCostBreakdown_receipt_details_order = _orderOrCostBreakdown_receipt_details1.order) === null || _orderOrCostBreakdown_receipt_details_order === void 0 ? void 0 : _orderOrCostBreakdown_receipt_details_order.fees) !== null && _orderOrCostBreakdown_receipt_details_order_fees !== void 0 ? _orderOrCostBreakdown_receipt_details_order_fees : {};
    var lineItems = _object_spread({}, (_orderOrCostBreakdown_receipt2 = orderOrCostBreakdown.receipt) === null || _orderOrCostBreakdown_receipt2 === void 0 ? void 0 : _orderOrCostBreakdown_receipt2.summary, taxLineItems, feeLineItems);
    var _lineItems_discounts;
    var discountValue = (_lineItems_discounts = lineItems === null || lineItems === void 0 ? void 0 : lineItems.discounts) !== null && _lineItems_discounts !== void 0 ? _lineItems_discounts : 0;
    var _lineItems_rewards;
    var rewardValue = (_lineItems_rewards = lineItems === null || lineItems === void 0 ? void 0 : lineItems.rewards) !== null && _lineItems_rewards !== void 0 ? _lineItems_rewards : 0;
    return _.reduce(lineItems, function(acc, value, key) {
        if (_.isString(key)) {
            var type = _.get(CHECKOUT_LINE_ITEM_MAPPING, key, key);
            // When the hideDiscountsFromConsumer store setting is enabled
            // we want to subtract the discounts present in the cost from the productSubtotal
            if ((hideDiscounts || hideSalesLanguage) && type === CHECKOUT_LINE_ITEM_MAPPING.subtotal) {
                value -= discountValue;
                value -= rewardValue;
            }
            // Skip discount/reward items when hiding
            if ((hideDiscounts || hideSalesLanguage) && (type === CHECKOUT_LINE_ITEM_MAPPING.discounts || type === CHECKOUT_LINE_ITEM_MAPPING.rewards)) {
                return acc;
            }
            acc.push({
                type: type,
                value: value / 100
            });
        }
        return acc;
    }, []);
}
